"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PickupPointsMap = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _shared = require("../shared");
var _MapFactory = require("./MapFactory");
var _PickupPointsMapDetail = require("./PickupPointsMapDetail");
var _jsxRuntime = require("react/jsx-runtime");
const MapContainer = (0, _mui.styled)('div')(({
  ownerState: {
    isMapVisible
  }
}) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  ...(!isMapVisible && (0, _shared.hiddenMapStyles)())
}));
const NavigationBar = (0, _mui.styled)('div')(({
  ownerState: {
    isCurrentLocationButtonVisible
  },
  theme
}) => ({
  alignItems: 'center',
  background: theme.palette.background.paper,
  borderRadius: 21,
  bottom: theme.spacing(isCurrentLocationButtonVisible ? 15 : 4),
  boxShadow: _mui.SHADOW_LEVEL1,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  justifyContent: 'center',
  position: 'absolute',
  right: theme.spacing(4),
  width: 42,
  zIndex: 999 // displayed under the selected details info
}));
const CurrentLocationButton = (0, _mui.styled)(_components.IconButton)(({
  theme
}) => ({
  bottom: theme.spacing(4),
  position: 'absolute',
  right: theme.spacing(4),
  zIndex: 999 // displayed under the selected details info
}));
const PickupPointsMap = props => {
  const {
    activeFilter,
    instantResultChannelId,
    instantSearchTerm,
    isMapVisible,
    onPickupPointItemConfirmation,
    selectedMapPickupPoint: selectedPickupPoint,
    setSelectedMapPickupPoint
  } = props;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    mapConfiguration,
    mapMethods
  } = (0, _hooks.usePickupPointsSearchConfiguration)();
  const {
    currentLocation,
    isCurrentLocationButtonVisible,
    locatePositionInMap,
    onMapInitialization
  } = (0, _hooks.useMapLocation)({
    instantResultChannelId,
    isActive: isMapVisible
  });
  const onPickupPointItemSelection = (0, _react.useCallback)(item => {
    setSelectedMapPickupPoint(item);
    if (item?.coordinates) {
      locatePositionInMap(item.coordinates, _models.MapLocationType.PickupPoint);
    }
  }, [locatePositionInMap, setSelectedMapPickupPoint]);
  const mapProps = {
    ...mapConfiguration,
    activeFilter,
    currentLocation,
    instantSearchTerm,
    isMapVisible,
    onMapInitialization,
    onPickupPointItemSelection,
    selectedPickupPoint
  };
  const navigationButtonProps = {
    color: 'default',
    size: 'large',
    variant: 'text'
  };
  const zoomInProps = {
    ...navigationButtonProps,
    onClick: () => {
      mapMethods.current?.zoomIn();
    }
  };
  const zoomOutProps = {
    ...navigationButtonProps,
    onClick: () => {
      mapMethods.current?.zoomOut();
    }
  };
  const currentLocationButtonProps = {
    color: 'default',
    onClick: () => {
      locatePositionInMap(currentLocation, _models.MapLocationType.CurrentButton);
    },
    size: 'large',
    variant: 'contained'
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(MapContainer, {
    "data-testid": getTestId(_models.TestId.MapContainer),
    ownerState: {
      isMapVisible
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MapFactory.MapFactory, {
      ...mapProps
    }), isMapVisible && selectedPickupPoint !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_PickupPointsMapDetail.PickupPointsMapDetail, {
      selectedPickupPoint: selectedPickupPoint,
      onPickupPointItemConfirmation: onPickupPointItemConfirmation
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(NavigationBar, {
      ownerState: {
        isCurrentLocationButtonVisible
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
        ...zoomInProps,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Add, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
        ...zoomOutProps,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Remove, {})
      })]
    }), isCurrentLocationButtonVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(CurrentLocationButton, {
      ...currentLocationButtonProps,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.MapSelector, {})
    }) : null]
  });
};
exports.PickupPointsMap = PickupPointsMap;
var _default = exports.default = PickupPointsMap;